/**
 * Menu lateral do cliente (Figma, out/2026 — pedido do Bruno): os links saíram
 * da barra superior para liberar espaço para a faixa de bandeiras e plano
 * (`navbar-status`). Fixo à esquerda, abaixo da barra; some no celular, onde
 * continua o menu que abre de lado (mesma lista, `navbar/menuItems`).
 */
import React from 'react';
import { useLocation } from 'react-router-dom';

import { useClientMenuItems } from 'components/navbar/menuItems';

import { SidebarContainer, SidebarLink } from './sidebar-menu.styles';

export const SidebarMenu = () => {
  const items = useClientMenuItems();
  const { pathname } = useLocation();

  return (
    <SidebarContainer aria-label="Menu principal">
      {items.map((item) => {
        const active = pathname.startsWith(item.match ?? item.to);
        return (
          <SidebarLink
            key={item.to}
            to={item.to}
            className={active ? 'active' : undefined}
            aria-current={active ? 'page' : undefined}
          >
            {item.icon}
            <span>{item.label}</span>
          </SidebarLink>
        );
      })}
    </SidebarContainer>
  );
};
